import { useQuery } from '@tanstack/react-query';
import getStudyReportContent from '../api/getStudyReportContent';
import ReportsSource, { reportsSourceId } from '../types/ReportsSource';
import StudyReportItem from '../types/StudyReportItem';

export const STUDY_REPORT_PDF_QUERY_KEY = 'StudyReportPdf';

// Caches the PDF as a Blob (not an object URL, which could never be revoked
// safely from the cache): react-pdf reads the Blob directly, and print /
// download create and revoke their own URLs.
const useReportPdf = (source: ReportsSource, report?: StudyReportItem) => {
  const sourceId = reportsSourceId(source);

  return useQuery({
    queryKey: [STUDY_REPORT_PDF_QUERY_KEY, sourceId, report?.sopInstanceUid],
    queryFn: () => getStudyReportContent(source, report!.sopInstanceUid, report!.seriesInstanceUid),
    enabled: !!sourceId && !!report,
    staleTime: 5 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};

export default useReportPdf;
